/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const AssignmentPercentageGradingSettingsParser = 
/* #__PURE__ */ parsers.object([
    ['scale', /* #__PURE__ */ parsers.exactly('percentage')],
]);
export class AssignmentPercentageGradingSettings extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AssignmentPercentageGradingSettingsParser.decode(input).map(res => new AssignmentPercentageGradingSettings(res));
    }
    static unsafeDecode(input) {
        return AssignmentPercentageGradingSettings.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AssignmentPercentageGradingSettingsParser.encode(data);
    }
    static schema() {
        return AssignmentPercentageGradingSettingsParser.schema();
    }
}
